import { AlertTypeFilterKeyString } from 'AlertsOfVulnerability/types'
import { ALERT_TYPE_FIELDS_INITIAL_VALUES } from '.'

export const ALERT_TYPE_INITIAL_FILTER: AlertTypeFilterKeyString = {
  search: '',
  ...ALERT_TYPE_FIELDS_INITIAL_VALUES,
}
